import React, { useState } from 'react';
import SoundWave from './SoundWave';

const SoundWaveDemo = () => {
  const [isActive, setIsActive] = useState(false);

  return (
    <div className="min-h-screen bg-gray-900 p-8">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold text-white mb-8 text-center">
          Sound Wave Component Demo
        </h1>
        
        <div className="space-y-12">
          {/* Basic Sound Wave */}
          <div className="bg-gray-800 rounded-lg p-6">
            <h2 className="text-xl font-semibold text-white mb-4">Basic Sound Wave</h2>
            <div className="bg-gray-700 rounded-lg p-6 flex items-center justify-center">
              <SoundWave 
                isActive={isActive}
                barCount={20}
                height="60px"
                color="#CDFFF9"
              />
            </div>
          </div>

          {/* Different Colors */}
          <div className="bg-gray-800 rounded-lg p-6">
            <h2 className="text-xl font-semibold text-white mb-4">Different Colors</h2>
            <div className="space-y-4">
              <div className="bg-gray-700 rounded-lg p-4 flex items-center justify-center">
                <SoundWave 
                  isActive={isActive}
                  barCount={15}
                  height="50px"
                  color="#FF6B6B"
                />
              </div>
              <div className="bg-gray-700 rounded-lg p-4 flex items-center justify-center">
                <SoundWave 
                  isActive={isActive}
                  barCount={15}
                  height="50px"
                  color="#4ECDC4"
                />
              </div>
              <div className="bg-gray-700 rounded-lg p-4 flex items-center justify-center">
                <SoundWave 
                  isActive={isActive}
                  barCount={15}
                  height="50px"
                  color="#45B7D1"
                />
              </div>
            </div>
          </div>

          {/* Different Sizes */}
          <div className="bg-gray-800 rounded-lg p-6">
            <h2 className="text-xl font-semibold text-white mb-4">Different Sizes</h2>
            <div className="space-y-4">
              <div className="bg-gray-700 rounded-lg p-4 flex items-center justify-center">
                <SoundWave 
                  isActive={isActive}
                  barCount={10}
                  height="30px"
                  color="#CDFFF9"
                />
              </div>
              <div className="bg-gray-700 rounded-lg p-4 flex items-center justify-center">
                <SoundWave 
                  isActive={isActive}
                  barCount={25}
                  height="80px"
                  color="#CDFFF9"
                />
              </div>
              <div className="bg-gray-700 rounded-lg p-4 flex items-center justify-center">
                <SoundWave 
                  isActive={isActive}
                  barCount={30}
                  height="100px"
                  color="#CDFFF9"
                />
              </div>
            </div>
          </div>

          {/* Control Button */}
          <div className="text-center">
            <button
              onClick={() => setIsActive(!isActive)}
              className={`px-8 py-3 rounded-lg font-semibold transition-all duration-200 ${
                isActive 
                  ? 'bg-red-500 hover:bg-red-600 text-white' 
                  : 'bg-green-500 hover:bg-green-600 text-white'
              }`}
            >
              {isActive ? 'Stop Animation' : 'Start Animation'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SoundWaveDemo;
